import React from 'react';
import FormHistory from 'modules/FormHistory';

const TargetReturn = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_da_target_return'
    : 'p_da_target_return';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;

};

export default TargetReturn;
